import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Condition from 'tuc-webui-base/services/Condition';
import fromConfiguration from '../../configuration/fromConfiguration';
import './TabsComponent.scss';

class TabsComponent extends React.PureComponent {
  static propTypes = {
    configuration: PropTypes.shape({}),
    components: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    properties: PropTypes.arrayOf(PropTypes.shape({})),
    data: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    viewService: PropTypes.shape({}).isRequired,
  }

  static defaultProps = {
    configuration: undefined,
    data: undefined,
    properties: undefined,
  }

  constructor(props) {
    super(props);

    this.state = {
      value: 0,
      ...this.updateFromProperties(props),
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.properties !== prevProps.properties) {
      this.setState(this.updateFromModels(this.props));
    }
  }

  updateFromProperties(props) {
    const { properties, viewService, configuration = {} } = props;
    const { tabs = [] } = configuration;
    const conditions = tabs.map(tab => (tab.if ? Condition(tab.if, properties, viewService) : null));
    return { conditions };
  }

  handleChange(e, value) {
    this.setState({ value });
  }

  render() {
    const { configuration = {}, components, data } = this.props;
    const { value, conditions = [] } = this.state;
    const makeTabKey = (c, i) => {
      return c.id || `tab-${i}`;
    };
    const makeCompKey = (c, i) => {
      return c.id || `tab-comp-${i}`;
    };
    const { tabs = [] } = configuration;
    const hiddenTabs = conditions.map(c => c && data && !c(data, this.props));
    const visibleIndices = hiddenTabs
            .map((h, i) => (h ? null : i)).filter(v => v !== null);
    let selectValue = value;
    if (hiddenTabs[value]) {
      let i = 0;
      while (i < hiddenTabs.length) {
        if (!hiddenTabs[i]) break;
        i += 1;
      }
      selectValue = i === hiddenTabs.length ? undefined : i;
    }
    return (
      <div className={classNames('grb-tabs-cntr', configuration.className)}>
        <header>
          <Tabs value={selectValue} onChange={this.handleChange}>
            {visibleIndices.map(i => (
              <Tab value={i} label={tabs[i].label} key={makeTabKey(tabs[i], i)} />
            ))}
          </Tabs>
        </header>
        <div className="grb-tabs-content">
          {visibleIndices.map((i) => {
            const Component = fromConfiguration(components[i]);
            return (
              <div
                className="grb-tab-component"
                style={{ visibility: i === selectValue ? 'visible' : 'hidden', order: i === selectValue ? 0 : (i === 0 && selectValue || i) }}
                key={makeCompKey(components[i], i)}
              >
                <Component {...this.props} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default TabsComponent;
